import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Container } from "@mantine/core";
import ReferralTable from "@/components/tables/ReferralTable";
import Navbar from "@/components/layout/Navbar";
import InlineBanner from "@/components/shared/InlineBanner";
import styles from "./home-page.module.scss";

function HomePage() {
  const location = useLocation();
  const [state, setState] = useState(location.state || {});

  return (
    <Navbar titleText="Home">
      <Container className={styles.homeContainer} fluid>
        {state.success && (
          <>
            <InlineBanner
              type="success"
              message="Referral sent! You may now refer another patient."
              key="Successful referral"
              dismissable
              onDismiss={() => setState({})}
            />
            <br />
          </>
        )}
        <ReferralTable />
      </Container>
    </Navbar>
  );
}

export default HomePage;
